import React from "react";

const ExperienceCard = ({ heading, duration, logo, onClick }) => {
  return (
    <div onClick={onClick} className="experienceCard">
      <img src={logo} alt="logoImg" className="w-12 h-12"></img>{" "}
      <div className="w-full">
        <h2 className="text-xs mdl:text-sm  text-designColor font-bold pb-1">
          {duration}
        </h2>
        <h2 className="text-xs mdl:text-sm text-black font-bodyFont">
          {heading}
        </h2>
      </div>
    </div>
  );
};

export default ExperienceCard;
